import React from "react";
import Popper from "@mui/material/Popper";
import { useMediaQuery } from "@mui/material";

const CustomPopper = (props) => {
  const isSmallScreen = useMediaQuery("(max-width:900px)");

  return (
    <Popper
      {...props}
      placement={isSmallScreen ? "bottom-end" : "bottom"}
      modifiers={[
        {
          name: "offset",
          options: {
            offset: [0, 0],
          },
        },
      ]}
      style={{
        ...props.style,
        minWidth: isSmallScreen ? "30%" : props.style?.width,
        maxWidth: "300px",
        zIndex: 1300,
      }}
    />
  );
};

export default CustomPopper;
